/* eslint-disable no-unused-vars */
export default class Session {
  constructor() {
    this.session = '';
  }
  static setTickets(uid, skey, domain) {
    if (domain) {
      document.cookie = `UID=${uid};path=/;domain=${domain};SameSite=none;Secure`;
      document.cookie = `SKEY=${skey};path=/;domain=${domain};SameSite=none;Secure`;
      document.cookie = `uin=${uid};path=/;domain=${domain};SameSite=none;Secure`;
    } else {
      document.cookie = `UID=${uid};path=/;SameSite=none;Secure`;
      document.cookie = `SKEY=${skey};path=/;SameSite=none;Secure`;
      document.cookie = `uin=${uid};path=/;SameSite=none;Secure`;
    }
    this.session = `UID=${uid};SKEY=${skey};/`;
  }
  static set(session) {
    this.session = session;
  }
  static get() {
    return this.session || '';
  }
  static getKey(key) {
    if (!this.session) return;
    const cookie = this.session;

    const m = cookie.match(new RegExp(`(^| |;)${key}=([^;]*)(;|$)`));
    return !m ? '' : decodeURIComponent(m[2]);
  }
  static setKeyToStorage(key, value) {
    // try {
    //   wx.setStorageSync(key, value);
    // } catch (err) {
    //   console.log(err);
    // }
  }
  static getKeyFromStorage(key, value) {
    // try {
    //   return wx.getStorageSync(key, value);
    // } catch (err) {
    //   console.log(err);
    //   return false;
    // }
    return false;
  }
}
